import { post, get } from '@/axios'

export interface UserGuideResponse {
  version: string
  accepted_at: string
}

export interface UserGuideRequest {
  type: number
  version: string
}

export const getUserGuide = async (params: { type: number }): Promise<UserGuideResponse> => {
  const resp = await get<UserGuideResponse>('/userAccept/get', params, {
    'Cache-Control': 'no-cache',
  })
  return resp.data
}

export const addUserGuide = async (data: UserGuideRequest): Promise<void> => {
  await post('/userAccept/set', data)
}
